import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Constants } from 'src/app/app.constants';
import { AlertService } from 'src/app/core/alert.service';
import { AuthService } from 'src/app/core/auth.service';
import { OptionsSource } from 'src/app/core/core.models';
import { DialogService } from 'src/app/core/dialog.service';
import { LoadingService } from 'src/app/core/loading.service';
import { TranslatorService } from 'src/app/core/translator.service';
import { UtilityService } from 'src/app/core/utility.service';
import { BusinessPartnersService } from 'src/app/inside-layout/routes/business-partners/business-partners.service';
import { BaseFormComponent } from '../../base/base-form.component';
import { ValueLabel } from '../../base/base.models';
import { BaseService } from '../../base/base.service';
import { Notification, NotificationPriority, NotificationType, NotificationTypeCreate } from '../notifications.models';
import { UsersService } from 'src/app/inside-layout/routes/users/users.service';

@Component({
  selector: 'app-notifications-form',
  templateUrl: './notifications-form.component.html',
  styleUrls: ['./notifications-form.component.scss']
})
export class NotificationsFormComponent extends BaseFormComponent implements OnInit {
  @Output() NewNotificationEvent = new EventEmitter();
  public types: ValueLabel[] = [];
  public priorties: ValueLabel[] = [];
  public businessPartners: OptionsSource;
  public users: OptionsSource;
  public NotificationType = NotificationType;

  constructor(
    public authService: AuthService,
    public loadingService: LoadingService,
    public translatorService: TranslatorService,
    public utilityService: UtilityService,
    protected activatedRoute: ActivatedRoute,
    protected baseService: BaseService,
    protected dialogService: DialogService,
    protected router: Router,
    protected alertService: AlertService,
    private businessPartnerService: BusinessPartnersService,
    private usersService: UsersService
    ) {
    super(authService, loadingService, translatorService, utilityService, activatedRoute, baseService, dialogService, router, alertService);
  }

  ngOnInit(): void { 
    this.authorities.init('S_NTF', 'R_NTF', null, null);
    this.url = `${Constants.contextPath}/notifications`;
    this.prepareLookupData();
    if(this.authService.hasAnyAuthority('S_NTF') || this.authService.hasAnyAuthority('S_NTF_C')){
      this.prepareFormData(new Notification(), (response: Notification) => {
        return this.modifyResponse(response);
      });
    }
    this.formData = new FormData();
  }

  prepareLookupData() {
    this.businessPartners = this.businessPartnerService.getBusinessPartnerLookup();
    this.types = this.utilityService.prepareLookupItems(this.utilityService.enumToSelectArray(NotificationTypeCreate, true), 'value', 'label', 'ENUMS.NOTIFICATION_TYPES_CREATE.');
    this.priorties = this.utilityService.prepareLookupItems(this.utilityService.enumToSelectArray(NotificationPriority, true), 'value', 'label', 'ENUMS.NOTIFICATION.');
    this.users = this.usersService.getUsersOptions();

    //filter types
    this.types = this.types.filter(type => (type.value == NotificationTypeCreate[NotificationTypeCreate.USER] && this.authService.hasAnyAuthority('R_USR')) || (type.value == NotificationTypeCreate[NotificationTypeCreate.PARTNER] && this.authService.hasAnyAuthority('R_PRTNR')));
  }

  public typeChanged = (event)=> {
    if(event.value) {
      delete this.formData.partners;
      delete this.formData.recipientUsers;
    }
  };

  public isForCompanyChanged = (event)=> {
    if(event.value == true) {
      this.formData.type = NotificationType[NotificationType.USER];
      delete this.formData.partners;
      delete this.formData.recipientUsers;
    }
  };

  public saveChanges(): void {
    if (!this.isFormValid())
      return;
    if(this.formData.type == NotificationType[NotificationType.USER] && this.formData.isForCompany == true) 
      this.baseService.patch(this.url+'/notify-company', { ...this.formData }, () => {
        this.NewNotificationEvent.emit();
        this.alertService.success('NOTIFICATIONS.MESSAGE_SENT_SUCCESSFULLY');
        this.router.navigate(['/dashboard/notifications/send']);
      });
    else
      this.baseService.create(this.url, { ...this.formData }, () => {
        this.NewNotificationEvent.emit();
        this.alertService.success('NOTIFICATIONS.MESSAGE_SENT_SUCCESSFULLY');
        this.router.navigate(['/dashboard/notifications/send']);
      });
  }
}
